module.exports = __webpack_public_path__ + "img/people_img_1_1.606c3450.png";